<app-top-nav></app-top-nav>

<!-- COLOCA AQUI O TEM A ROTA MANDA -->
<router-outlet></router-outlet>

<app-footer></app-footer>
